import React from 'react';
import { connect } from 'react-redux';
import { Glyphicon } from 'react-bootstrap';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import {
  UrlWrappedLink, LinkLikeButton,
} from '../../../../util/util.jsx';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';
import { List as DictList, mapDispatchToProps } from '../../simple/List';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';
import trash from '../../../../../style/trash.png';
import pencil from '../../../../../style/pencil.png';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { getTextFilter } from '@/component/form/ReactBootstrapTableTextFilter';

export class List extends DictList {
  constructor(props) {
    super(props);
    this.renderModificationButtons = this.renderModificationButtons.bind(this);
    this.renderNameColumn = this.renderNameColumn.bind(this);
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }

  getNameColumn = () => <TableHeaderColumn
    dataField="name" dataSort
    className={'references-name-header'}
    columnClassName={'references-name-row'}
    dataFormat={this.renderNameColumn}
    filter={{ type: 'CustomFilter',
      getElement: getTextFilter,
      customFilterParameters: { columnName: `${this.name} name` },
    }}
  >
    {this.name ? `${this.name} name` : 'Name'}
  </TableHeaderColumn>

  renderModificationButtons(id, ref) {
    return (<div className={'reference-mod-column'}>
      {ref.hidden ?
        <RoleConfigFilter permissions={['references#2']}>
          <LinkLikeButton onClick={() => this.restore(id)}>
            <Glyphicon
              title="Restore" id={`restore_${id}`} glyph="repeat"
            />
          </LinkLikeButton>
        </RoleConfigFilter>
        :
        <div>
          {ref.predefine
            ? ''
            :
            <RoleConfigFilter permissions={['references#3']}>
              <LinkLikeButton
                onClick={() => {
                  this.openModal(id);
                }}
              >
                <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
              </LinkLikeButton>
            </RoleConfigFilter>
          }
        </div>
      }
      <RoleConfigFilter permissions={['references#2']}>
        <UrlWrappedLink url={`/references/${ref.refPath}/${id}`} id={`edit_${id}`}>
          <img
            src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
          />
        </UrlWrappedLink>
      </RoleConfigFilter>
    </div>);
  }

  renderNameColumn(name, data) {
    return (<div>
      <span
        style={{
          minWidth: 140,
          display: 'inline-block',
        }}
      >
        {name}
      </span>
      <span>
        {
          data.isPurchase
            ?
            <span
              className={'expenses-type-tag'}
              style={{
                background: '#EBECF9',
              }}
            >
              Purchase
            </span>
            : ''
        }
        {
          data.isSale
            ?
            <span
              className={'expenses-type-tag'}
              style={{
                background: '#F4E7E9',
              }}
            >
              Sale
            </span>
            : ''
        }
        {
          data.isTransport
            ?
            <span
              className={'expenses-type-tag'}
              style={{
                background: '#e6feea',
              }}
            >
              Transport
            </span>
            : ''
        }
        {
          data.common
            ?
            <span
              className={'expenses-type-tag'}
              style={{
                background: '#fefce6',
              }}
            >
              Common
            </span>
            : ''
        }
      </span>
    </div>);
  }
}

export default connect((state) =>
  ({
    refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()),
  }),
mapDispatchToProps(REF_NAME, REF_PATH)
)(List);
